import { useStaticQuery, graphql } from "gatsby";
import { ProductFields } from "./fragments";
export const UseGetProductsByLayeringSystem = () => {
  const data = useStaticQuery(graphql`
    query getAllProductsByLayeringSystem {
      Base_Layer: shopifyCollection(handle: { eq: "base-layers" }) {
        ...ProductFields
      }
      Mid_Layer: shopifyCollection(handle: { eq: "mid-layers" }) {
        ...ProductFields
      }
      Insulation_Layer: shopifyCollection(handle: { eq: "insulation-layers" }) {
        ...ProductFields
      }
      Outer_Layer: shopifyCollection(handle: { eq: "waterproof-layers" }) {
        ...ProductFields
      }
    }
  `);
  return data;
};
